import { useMemo } from 'react';

import { TEMPLATE_STATUS } from 'src/data/template';
import { usePreparedMultiPromptTemplates } from 'src/services';

/**
 * Provide a list of "saved" multi-prompt templates
 *
 * @param {object} [options] - options
 * @param {boolean} options.includeDrafts - should templates in "draft" status be included
 * @returns {object[]} - saved multi-prompt templates
 */
export const useSavedMultiPromptTemplates = (options) => {
  const preparedTemplates = usePreparedMultiPromptTemplates();

  const includeDrafts = Boolean(options?.includeDrafts);
  return useMemo(() => {
    const allowedStatuses = includeDrafts
      ? [TEMPLATE_STATUS.active, TEMPLATE_STATUS.draft]
      : [TEMPLATE_STATUS.active];

    return preparedTemplates.filter((template) => allowedStatuses.includes(template.status));
  }, [preparedTemplates, includeDrafts]);
};
